import React from 'react'
import Layout from '../../components/BridgePage/Layout'
import './index.scss'

const AboutCg = () => (
  <Layout>
    <div className='aboutCg'>
      <h1 className='CgTitle'>Community Guidelines</h1>

      <h2>I. Special Reminder</h2>
      <p>
        The services provided to you by Huna are subject to Huna's Terms of Service and any other policies or guidelines posted by Huna at any time. Huna will promptly notify you in case of any changes to these Community Guidelines. Updated Community Guidelines will take effect immediately after being posted online, replacing previous versions.
      </p>
      <p>
        You understand and acknowledge that you are fully responsible for any content you submit or contribute via streaming, posting, uploading, publishing, transmitting, or otherwise making available on the Huna platform. This includes ensuring the legality, reliability, accuracy, and appropriateness of such content.
      </p>
      <p>
        Additionally, Huna reserves the right to terminate or suspend your access to its services or modify the services provided as part of its operational adjustments.
      </p>
      <p>
        You agree not to directly or indirectly violate these Community Guidelines or applicable laws, regulations, and public order requirements. This includes, but is not limited to, the laws, regulations, and public order of the regions where Huna operates or where your content is made available.
      </p>

      <h2>II. Prohibited Content</h2>
      <p>To maintain a positive experience for all users, Huna strictly prohibits certain behaviors, including but not limited to the following:</p>
      <ol>
        <li><strong>Propagation of Violence and Crime</strong>
          <ul>
            <li>Content that constitutes, encourages, or provides instructions for criminal activities, dangerous actions, or self-harm.</li>
            <li>Content containing threats of any kind, including physical violence, harassment, trolling, or bullying.</li>
            <li>Promotion of terrorism, extremism, or related activities.</li>
            <li>Defamatory, obscene, offensive, hateful, or inflammatory materials.</li>
            <li>Content that endorses or promotes violence against animals, vandalism, destruction of property, or poaching of endangered species.</li>
          </ul>
        </li>
        <li><strong>Publication of Controlled or Illegal Items</strong>
          <ul>
            <li>Content describing the production, transaction, or use of illegal drugs or substances.</li>
            <li>Facilitating the exchange or sale of firearms, ammunition, explosives, or weapon parts.</li>
            <li>Coordinating or supporting poaching or trade involving endangered species.</li>
            <li>Any content involving contraband as defined by local regulations.</li>
          </ul>
        </li>
        <li><strong>Violation of Others' Rights or Platform Integrity</strong>
          <ul>
            <li>Uploading files containing malicious code such as viruses, trojans, or worms.</li>
            <li>Sharing third-party private information (e.g., addresses, phone numbers, ID numbers) without consent.</li>
            <li>Promoting competing platforms through text, voice, or images.</li>
            <li>Uploading content that infringes on intellectual property rights or privacy.</li>
          </ul>
        </li>
        <li><strong>Sexually Explicit Content</strong>
          <ul>
            <li>Displaying or implying sexual acts, nudity, or other explicit behavior.</li>
            <li>Sharing content with sexual innuendos, harassment, or advances without consent.</li>
          </ul>
        </li>
        <li><strong>Discriminatory Content</strong>
          <ul>
            <li>Racist or discriminatory content targeting someone’s race, religion, age, gender, disability, or sexual orientation is strictly prohibited.</li>
          </ul>
        </li>
        <li><strong>Impersonation</strong>
          <ul>
            <li>Impersonating any individual or entity, including Huna officials, is strictly forbidden.</li>
            <li>Spreading false information while impersonating official staff.</li>
            <li>Using a false identity to deceive or threaten others.</li>
          </ul>
        </li>
        <li><strong>Commercial or Unauthorized Use</strong>
          <ul>
            <li>Sharing spam, advertisements, or unauthorized solicitations.</li>
            <li>Promoting unauthorized links for financial gain.</li>
          </ul>
        </li>
        <li><strong>Violation of Laws and Ethical Standards</strong>
          <ul>
            <li>Content contradicting the constitutional or legal provisions of applicable countries, promoting unethical behavior, or violating public order is strictly prohibited.</li>
          </ul>
        </li>
        <li><strong>Content Harmful to Minors</strong>
          <ul>
            <li>Sexualization or fetishization of minors.</li>
            <li>Sharing images, videos, or other content featuring child nudity.</li>
            <li>Content depicting violence against children in any form.</li>
          </ul>
        </li>
        <li><strong>Gambling Activities</strong>
          <ul>
            <li>Using Huna for gambling, including transactions involving in-app virtual currency, is prohibited.</li>
          </ul>
        </li>
        <li><strong>Fraud and Illegal Transactions</strong>
          <ul>
            <li>Activities like unauthorized selling of virtual items (e.g., diamonds), scams, or impersonating officials to defraud others are strictly forbidden.</li>
          </ul>
        </li>
      </ol>

      <h2>III. Enforcement and Reporting</h2>
      <p>
        Huna staff actively review content to ensure compliance with these Community Guidelines. Users are also encouraged to report behaviors that violate the guidelines. If a violation is confirmed, Huna reserves the right to:
      </p>
      <ul>
        <li>Remove inappropriate content.</li>
        <li>Suspend user accounts.</li>
        <li>Report incidents to relevant authorities as required by law.</li>
      </ul>

      <h3>Report Channels</h3>
      <p>
        We encourage you to report any suspected violations via the following channels: <strong>report@huna.live</strong>
      </p>
    </div>
  </Layout>
)

export default AboutCg
